import { render } from "./RenewalContent.vue?vue&type=template&id=0b07a460"
import script from "./RenewalContent.vue?vue&type=script&lang=js"
export * from "./RenewalContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__